export const JOB_CAREER_STAGE_OPTIONS = [
  'Apprenticeships & Early Careers',
  'Entry Level',
  'Experienced',
  'Management',
  'Senior Leadership',
];

export const getEffectiveCareerStage = job => (
  String(job?.career_stage_override || '').trim()
  || String(job?.career_stage || '').trim()
  || 'Experienced'
);

export const shouldFeatureCareerStageBadge = job => [
  'Apprenticeships & Early Careers',
  'Entry Level',
  'Senior Leadership',
].includes(getEffectiveCareerStage(job));

export const careerStageJobsUrl = careerStage => {
  const params = new URLSearchParams();
  params.append('stages', careerStage);
  return `/jobs?${params.toString()}`;
};

